






























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import vehicleTypeModule from '../modules/vehicleTypeModule'
import SearchAreaModel from '../models/SearchAreaModel'
import SearchAreaStatusEnum from '../enums/searchAreaStatusEnum'
import vehicleType from '../models/vehicleTypeModel'

@Component
export default class Breadcrumb extends Vue {
  @Getter('step') currentStep!: number;
  @Getter('reportVehicleType') reportVehicleType!: vehicleType;
  @Getter('searchAreas') searchAreas!: Array<SearchAreaModel>;

  get reportVehicleTypeLabel () {
    return this.reportVehicleType.name
      ? this.reportVehicleType.name
      : 'Select a vehicle'
  }

  getSearchAreaByStep (step: number) {
    if (this.reportVehicleType.searchAreas.length === 0) {
      return false
    } else {
      return this.reportVehicleType.searchAreas[step - 2]
    }
  }

  get reportOk () : boolean {
    let reportOk = true
    for (let index = 0; index < this.searchAreas.length; index++) {
      if (this.searchAreas[index].status !== SearchAreaStatusEnum.Accepted) {
        reportOk = false
        break
      }
    }

    return reportOk
  }

  get allAreasChecked () : boolean {
    let checkOk = true
    for (let index = 0; index < this.searchAreas.length; index++) {
      if (this.searchAreas[index].status === SearchAreaStatusEnum.InProgress) {
        checkOk = false
        break
      }
    }

    return checkOk
  }

  searchAreaOk (step: number) {
    const searchArea = this.getSearchAreaByStep(step)
    return searchArea.status === SearchAreaStatusEnum.Accepted
  }

  getBgColorCircle (step: number) {
    const searchOk = this.getSearchAreaByStep(step)
    switch (searchOk.status) {
    case SearchAreaStatusEnum.InProgress:
      return 'bg-temp'
    case SearchAreaStatusEnum.Declined:
      return 'bg-red'
    case SearchAreaStatusEnum.Accepted:
      return 'bg-green'
    }
  }

  breadcrumbLabel (step: any) {
    switch (step) {
    case 1:
      return this.$t(this.reportVehicleTypeLabel)
    case 2:
    case 3:
    case 4:
      return this.searchAreas[step - 2] !== undefined && step === this.currentStep
        ? this.$t(this.searchAreas[step - 2].label)
        : false
    case 5:
      return 'Report'
    default:
      break
    }
  }

  goTo (step: any) {
    switch (step) {
    case 1:
      break
    case 2:
    case 3:
    case 4:
      this.$router.push({ name: 'inspection', params: { step: step } })
      break
    case 5:
      if (this.currentStep !== 1) {
        this.$router.push({ name: 'report' })
      }
      break
    default:
      break
    }
  }

  get iconName () {
    if (this.reportVehicleType.name) {
      return this.reportVehicleType.name.toLowerCase()
    } else {
      return 'question'
    }

  }

}
